// extracted by mini-css-extract-plugin
module.exports = {"main":"gear_main__2RNjl","textOrange":"gear_textOrange__2da54"};